import { queryStringify} from "../utils"
 
const DEV_58 = 'http://dev58.myzaker.com/mlab.myzaker.com/?model='
const PROD = 'http://mlab.myzaker.com/?model='

export const pages = {
    dev: {
        index: './index.html',
        home: './home.html',
        admin: './admin.html'
    },
    dev58: {
        home: DEV_58+'home',
        admin: DEV_58+'admin'
    },
    prod: {
        home: PROD + 'home',
        admin: PROD + 'admin'
    },
    getUrl: (name, queryObj, isEncode=true) => {
        let url
        let query = queryStringify(queryObj, isEncode)
        if (process.env.NODE_ENV == 'development') {
            url = pages.dev[name] + '?' + query
        } else if (location.href.indexOf('121.9.213.58') != -1 || location.href.indexOf('http://dev58.myzaker.com') != -1) {
            url = pages.dev58[name] + query
        } else {
            url = pages.prod[name] + query
        }
        return url
    }
}


// WEBPACK FOOTER //
// ./pc/index/config/pages.js